import {AfterViewInit, Component, Input, OnInit, OnChanges, SimpleChange, Output, EventEmitter} from '@angular/core';
import {PointOfSaleDto} from "../../point-of-sale-dto";
import {NotificationService} from "../../../../root/toast/notification.service";
import {GAService} from "../../../../root/ga/ga.service";


@Component({
    selector: 'orlando-modal-new-delivery-point',
    templateUrl: './orlando-modal-new-delivery-point.component.html',
    providers: []
})
export class OrlandoModalNewDeliveryPointComponent implements OnInit, AfterViewInit, OnChanges{

    @Input() errors;
    @Input() dto:PointOfSaleDto;
    @Output() closeModal = new EventEmitter<boolean>();
    @Output() meetingPointAdded = new EventEmitter<boolean>();

    terminalSelected:any = null;
    terminals:any[];
    stopDisabled:boolean = true;
    ranges:any[] = Array();
    errorInStop:boolean;

    errorSingleStop:boolean;
    errorMinValueRangeStop:boolean;
    errorMaxValueRangeStop:boolean;


    errorTextInTerminal:string;
    errorTextInStop:string;
    MIN_VALUE_RANGE:number = 1;
    MAX_VALUE_RANGE:number = 62;
    public mask = [/\d/, /\d/];
    GA_NOTIFY_CATEGORY = "Autos_MCO_Indications";

    constructor(private notificationService:NotificationService, private gaService: GAService){

        this.terminals = [
            {
                index:0,
                terminal: "A",
                selected:false,
                counters:{radioSingleStop:false, radioRangeStop:false}},
            {
                index:1,
                terminal: "B",
                selected:false,
                counters:{radioSingleStop:false, radioRangeStop:false}}
        ];
    }

    ngAfterViewInit(): void {
    }

    ngOnInit(): void {

        //We need insert into to range array, each value of dto.pickupIndications.orlandoAirportPositions
        this.dto.pickupIndications.orlandoAirportPositions.forEach(orlandoPosition => {
            let range = {terminal:"",values:[]};
            range.terminal = orlandoPosition.terminal;

            if(orlandoPosition.stop){
                range.values = [orlandoPosition.stop];
            }else {
                //completing values between the min and max values
                let currentValue:number = orlandoPosition.range.minValue;
                range.values.push(currentValue);

                while(currentValue < orlandoPosition.range.maxValue){
                    currentValue++;
                    range.values.push(currentValue);
                }
            }
            this.ranges.push(range);
        });

    }

    ngOnChanges(changes:  {[propKey: string]: SimpleChange}): void {

    }

    gaNotify() {
        if (this.isAddMeetingPointDisabled()) {
            this.gaService.notify(this.GA_NOTIFY_CATEGORY, "add_to_list", ["disabled"]);
        }
    }

    isAddMeetingPointDisabled():boolean {
        const radioSingleStop = document.getElementById("radioSingleStop") as HTMLInputElement;
        const radioRangeStop = document.getElementById("radioRangeStop") as HTMLInputElement;
        const singleStop = document.getElementById("singleStop") as HTMLInputElement;
        const rangeStopFrom = document.getElementById("rangeStopFrom") as HTMLInputElement;
        const rangeStopTo = document.getElementById("rangeStopTo") as HTMLInputElement;
        const singleStopHasValue = radioSingleStop.checked && singleStop.value;
        const rangeStopHasValue = radioRangeStop.checked && rangeStopFrom.value && rangeStopTo.value;

        return !this.terminalSelected || !(singleStopHasValue || rangeStopHasValue);
    }

    getClassTerminalSelected(){
        for(let i=0;i < this.terminals.length;i++){
            if(this.terminals[i].selected){
                return "-selected-" + this.terminals[i].index;
            }
        }
        return "-selected--1";
    }

    isValueInRange(existingRanges:any[],rangeToEvaluate:any):boolean {

        for(let i = 0; i < existingRanges.length; i++){
            if(existingRanges[i].terminal === rangeToEvaluate.terminal){
                for(let j = 0; j < rangeToEvaluate.values.length; j++){
                    if(existingRanges[i].values.includes(rangeToEvaluate.values[j])){
                        return false;
                    }
                }
            }else{
                continue;
            }
        }
        return true;
    }

    addNewMeetingPoint():void {

        if(this.isValidData()){
            const radioSingleStop = document.getElementById("radioSingleStop") as HTMLInputElement;
            const radioRangeStop = document.getElementById("radioRangeStop") as HTMLInputElement;
            let range = {terminal:"",values:[]};
            let orlandoAirportPositions = {
                terminal:"",
                stop:0,
                range:{minValue:0,maxValue:0}};

            //setting the value for single or range stop
            if(radioSingleStop.checked){
                const txtSingleStop = document.getElementById("singleStop") as HTMLInputElement;
                this.terminals[this.terminalSelected.index].counters.radioSingleStop = true;
                range.values.push(parseInt(txtSingleStop.value));
                orlandoAirportPositions.stop = parseInt(txtSingleStop.value);
                orlandoAirportPositions.range = null;

            }else if(radioRangeStop.checked){
                const rangeStopFrom = document.getElementById("rangeStopFrom") as HTMLInputElement;
                const rangeStopTo = document.getElementById("rangeStopTo") as HTMLInputElement;
                this.terminals[this.terminalSelected.index].counters.radioRangeStop = true;
                orlandoAirportPositions.stop = null;
                orlandoAirportPositions.range = {
                    minValue:parseInt(rangeStopFrom.value),
                    maxValue:parseInt(rangeStopTo.value)
                };

                //completing values between the min and max values
                let currentValue:number = parseInt(rangeStopFrom.value);
                range.values.push(parseInt(rangeStopFrom.value));

                while(currentValue < parseInt(rangeStopTo.value)){
                    currentValue++;
                    range.values.push(currentValue);

                }
                range.values.push(parseInt(rangeStopTo.value));
            }

            //setting the terminal selected
            orlandoAirportPositions.terminal = this.terminalSelected.terminal;
            range.terminal = this.terminalSelected.terminal;

            //validate the range
            if(this.isValueInRange(this.ranges,range)){
                this.gaService.notify(this.GA_NOTIFY_CATEGORY, "add_to_list", ["success"]);
                this.ranges.push(range);
                this.dto.pickupIndications.orlandoAirportPositions.push(orlandoAirportPositions);
                this.notificationService.showToast("pickupPoint.additional_points.toast.meeting_point_created", null, null,"SUCCESS",5000);
                this.meetingPointAdded.emit(true);
                this.showModalNewDeliveryPoint(false);
            }else{
                this.errorInStop = true;

                if(radioSingleStop.checked){
                    this.errorSingleStop = true;
                    this.errorTextInStop = "pickupPoint.sited_in_airport.modal.error.stop_duplicated";
                }else{
                    this.errorTextInStop = "pickupPoint.agent_in_terminal.stop.overlap";
                }
                this.gaService.notify(this.GA_NOTIFY_CATEGORY, "add_to_list", ["failure"]);
            }
        } else {
            this.gaService.notify(this.GA_NOTIFY_CATEGORY, "add_to_list", ["failure"]);

        }
    }

    isValidData():boolean {
        this.errorInStop = false;
        const radioSingleStop = document.getElementById("radioSingleStop") as HTMLInputElement;
        const radioRangeStop = document.getElementById("radioRangeStop") as HTMLInputElement;
        const rangeStopFrom = document.getElementById("rangeStopFrom") as HTMLInputElement;
        const rangeStopTo = document.getElementById("rangeStopTo") as HTMLInputElement;
        const singleStop = document.getElementById("singleStop") as HTMLInputElement;

        //check single or range stop selected
        if(!(radioSingleStop.checked || radioRangeStop.checked)){
            this.errorInStop = true;
            this.errorTextInStop = 'pickupPoint.agent_in_terminal.stop.required';
            return false;
        }

        if(radioSingleStop.checked){
            //validating required value for single stop
            if(!singleStop.value || singleStop.value === ""){
                this.errorInStop = true;
                this.errorTextInStop = 'pickupPoint.agent_in_terminal.stop.single_stop_required';
                return false;
            }

            //validating out of range for single stop
            if(parseInt(singleStop.value) < this.MIN_VALUE_RANGE || parseInt(singleStop.value) > this.MAX_VALUE_RANGE){
                this.errorInStop = true;
                this.errorTextInStop = 'pickupPoint.sited_in_airport.modal.error.stop_out_range';
                return false;
            }
        }

        if(radioRangeStop.checked){
            //validating required value for min value of range stop
            if(!rangeStopFrom.value || rangeStopFrom.value === ""){
                this.errorInStop = true;
                this.errorTextInStop = 'pickupPoint.agent_in_terminal.stop.range_stop_required';
                return false;
            }

            //validating required value for max value of range stop
            if(!rangeStopTo.value || rangeStopTo.value === ""){
                this.errorInStop = true;
                this.errorTextInStop = 'pickupPoint.agent_in_terminal.stop.range_stop_required';
                return false;
            }

            //validating out of range for min and max value
            if(parseInt(rangeStopFrom.value) < this.MIN_VALUE_RANGE || parseInt(rangeStopFrom.value) > this.MAX_VALUE_RANGE
                || parseInt(rangeStopTo.value) > this.MAX_VALUE_RANGE || parseInt(rangeStopTo.value) < this.MIN_VALUE_RANGE){
                this.errorInStop = true;
                this.errorTextInStop = 'pickupPoint.sited_in_airport.modal.error.stop_out_range';
                return false;
            }

            //validating that the minimum value is less than the maximum value
            if(parseInt(rangeStopFrom.value) >= parseInt(rangeStopTo.value)){
                this.errorInStop = true;
                this.errorTextInStop = 'pickupPoint.sited_in_airport.modal.error.max_less_min';
                return false;
            }
        }

        return true;
    }

    selectTerminal(indexTerminal, value){
        this.blankSelectedTerminal();
        this.blankRadioSelectLocationCounter();
        this.terminals[indexTerminal].selected = value;
        const radioSingleStop = document.getElementById("radioSingleStop") as HTMLInputElement;
        const radioRangeStop = document.getElementById("radioRangeStop") as HTMLInputElement;

        if(value){
            this.terminalSelected = this.terminals[indexTerminal];
            this.stopDisabled = false;
        }else{
            this.terminalSelected = null;
            this.stopDisabled = true;
        }
        radioSingleStop.disabled = false;
        radioRangeStop.disabled = false;
        this.gaService.notify(this.GA_NOTIFY_CATEGORY, "terminal", [this.terminals[indexTerminal].terminal]);
    }

    selectSingleStop(){
        const singleStop = document.getElementById("singleStop") as HTMLInputElement;
        const rangeStopFrom = document.getElementById("rangeStopFrom") as HTMLInputElement;
        const rangeStopTo = document.getElementById("rangeStopTo") as HTMLInputElement;
        singleStop.disabled = false;
        rangeStopFrom.disabled = true;
        rangeStopTo.disabled = true;
        singleStop.value = "";
        rangeStopFrom.value = "";
        rangeStopTo.value = "";
        this.errorInStop = false;
        this.gaService.notify(this.GA_NOTIFY_CATEGORY, "platform", ["single"]);
    }

    selectRangeStop(){
        const singleStop = document.getElementById("singleStop") as HTMLInputElement;
        const rangeStopFrom = document.getElementById("rangeStopFrom") as HTMLInputElement;
        const rangeStopTo = document.getElementById("rangeStopTo") as HTMLInputElement;
        singleStop.disabled = true;
        rangeStopFrom.disabled = false;
        rangeStopTo.disabled = false;
        singleStop.value = "";
        rangeStopFrom.value = "";
        rangeStopTo.value = "";
        this.errorInStop = false;
        this.gaService.notify(this.GA_NOTIFY_CATEGORY, "platform", ["range"]);
    }

    getTerminalSelected():number{
        for(let i=0;i < this.terminals.length;i++){
            if(this.terminals[i].selected){
                return this.terminals[i].index;
            }
        }
        return 0;
    }

    blankSelectedTerminal(){
        this.terminalSelected = null;

        for(let i=0;i < this.terminals.length;i++){
            this.terminals[i].selected = false;
        }
    }

    blankRadioSelectLocationCounter(){
        let radioSingleStop = document.getElementById("radioSingleStop") as HTMLInputElement;
        let radioRangeStop = document.getElementById("radioRangeStop") as HTMLInputElement;
        let txtSingleStop = document.getElementById("singleStop") as HTMLInputElement;
        let txtRangeStopFrom = document.getElementById("rangeStopFrom") as HTMLInputElement;
        let txtRangeStopTo = document.getElementById("rangeStopTo") as HTMLInputElement;

        if(txtSingleStop.value === ""){
            txtSingleStop.disabled = true;
            radioSingleStop.checked = false;
        }

        if(txtRangeStopFrom.value === "" && txtRangeStopTo.value === ""){
            radioRangeStop.checked = false;
        }

        if(txtRangeStopFrom.value === ""){
            txtRangeStopFrom.disabled = true;
        }

        if(txtRangeStopTo.value === ""){
            txtRangeStopTo.disabled = true;
        }

        this.errorInStop = false;
        this.errorTextInStop = "";
    }


    focusOutSingleStop() {
        let singleStop = document.getElementById("singleStop") as HTMLInputElement;
        this.gaService.notify(this.GA_NOTIFY_CATEGORY, "platform_single", [singleStop.value]);
    }

    focusOutRangeStopFrom() {
        let rangeStopFrom = document.getElementById("rangeStopFrom") as HTMLInputElement;
        this.gaService.notify(this.GA_NOTIFY_CATEGORY, "platform_from", [rangeStopFrom.value]);
    }

    focusOutRangeStopTo() {
        let rangeStopTo = document.getElementById("rangeStopTo") as HTMLInputElement;
        this.gaService.notify(this.GA_NOTIFY_CATEGORY, "platform_to", [rangeStopTo.value]);
    }

    showModalNewDeliveryPoint(value){
        this.closeModal.emit(value);
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/delivery-instructions/orlando-instructions/orlando-modal-new-delivery-point.component.ts